import React from 'react';

import { useTranslation } from 'react-i18next';

import { Button, Modal, ToastContext, Message } from '@weezevent/nacre';

export default function DeleteModal({ waitingList = null, organization, sync = () => {}, onClose = () => {} }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const [isLoading, setIsLoading] = React.useState(false);

    const onSubmit = React.useCallback(() => {
        setIsLoading(true);
        waitingList
            .delete({
                id: waitingList.id,
                organizationId: organization.id
            })
            .then(() => {
                toast.success(t('ticket.waiting_list.delete_modal.toast-success'));
                onClose();
                setIsLoading(false);
                sync();
            })
            .catch(e => {
                console.error(e);
                toast.error(t('ticket.waiting_list.delete_modal.toast-error'));
                setIsLoading(false);
            });
    }, [organization, waitingList, t, toast, sync, onClose]);

    if (!waitingList) {
        return null;
    }

    return (
        <Modal
            title={t('ticket.waiting_list.delete_modal.title')}
            allowExternalClosing={false}
            open={Boolean(waitingList)}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.common.action.confirm')} onClick={onSubmit} isLoading={isLoading} />}
            cancelButton={<Button onClick={onClose} label={t('ticket.common.action.cancel')} disabled={isLoading} />}
        >
            <div style={{ marginTop: '15px' }}>
                <Message type="warning" title={t('ticket.waiting_list.delete_modal.message-title')}>
                    {t('ticket.waiting_list.delete_modal.description')}
                </Message>
            </div>
        </Modal>
    );
}
